import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import { loginRequest, msalConfig } from "./useAuth";
import store from "app/store";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import getEnv from "env";

const msalInstance = new PublicClientApplication(msalConfig);

const REACT_APP_VIATRACKING_API_URL = getEnv("REACT_APP_VIATRACKING_API_URL");
const REACT_APP_KITCOLETA_API_KEY = getEnv("REACT_APP_KITCOLETA_API_KEY");

export const getAccessTokenStorage = () =>
  sessionStorage.getItem("AccessToken");

export const getUserOID = () => {
  const sessionId: any = sessionStorage.getItem("SessionID");
  return sessionId;
};

const requestConfigInterceptor = (config) => {
  const accessToken = getAccessTokenStorage();
  const customConfig = {
    ...config,
    headers: { ...config.headers, "viatracking-session-id": getUserOID() },
  };

  if (!accessToken) {
    throw new Error("no access token");
  }

  // customConfig.headers.Authorization = `Bearer ${accessToken}`;

  return customConfig;
};

export const apiKitColetaInstance = axios.create({
  baseURL: `${REACT_APP_VIATRACKING_API_URL}/transportation/api/v1/kit/coleta`,
  timeout: 100000,
  headers: {
    "viatracking-session-id": getUserOID(),
    apiKey: REACT_APP_KITCOLETA_API_KEY,
  },
});

const useResponseErrorInterceptor = async (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      await msalInstance.logoutRedirect(loginRequest);
    } else if (error.response.status === 403) {
      store.dispatch(
        openModalError({
          title: "Acesso negado",
          text: "Desculpe, você não tem permissão para acessar este recurso. Por favor, verifique suas credenciais e tente novamente ou entre em contato com o administrador para obter mais informações.",
          btnLabel: "Fechar",
        })
      );
    } else {
      return Promise.reject(error.response);
    }
  }
};

const withInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(requestConfigInterceptor, (error) =>
    Promise.reject(error)
  );
  axiosInstance.interceptors.response.use(
    (response) => response,
    useResponseErrorInterceptor
  );

  return axiosInstance;
};

export const API_KIT_COLETA = withInterceptor(apiKitColetaInstance);
